// extracted by mini-css-extract-plugin
module.exports = {"content":"style-module--content--2m_mE","title":"style-module--title--3U3ZS","copy":"style-module--copy--3JFta"};